import * as React from "react";
import { gql, useMutation, MutationHookOptions, MutationTuple } from "@apollo/client";
import {
  UpdateCustomerToAmbassadorMutation,
  UpdateCustomerToAmbassadorMutationVariables
} from "../../../../../schemaTypes";

export const updateCustomerToAmbassadorMutation = gql`
  mutation UpdateCustomerToAmbassador(
    $id: String!
  ) {
    updateCustomerToAmbassador(
      id: $id
    ) {
      errors {
        path
        message
      }
      message
    }
  }
`;

export interface WithUpdateCustomerToAmbassador {
  updateCustomerToAmbassador: MutationTuple<
    UpdateCustomerToAmbassadorMutation,
    UpdateCustomerToAmbassadorMutationVariables
  >[0];
}


interface UpdateCustomerToAmbassadorProps {
  children: (data: WithUpdateCustomerToAmbassador) => React.ReactElement | null;
  options?: MutationHookOptions<
    UpdateCustomerToAmbassadorMutation,
    UpdateCustomerToAmbassadorMutationVariables
  >;
}

export const UpdateCustomerToAmbassador: React.FC<UpdateCustomerToAmbassadorProps> = ({ children, options }) => {
  const [updateCustomerToAmbassador] = useMutation<
    UpdateCustomerToAmbassadorMutation,
    UpdateCustomerToAmbassadorMutationVariables
  >(
    updateCustomerToAmbassadorMutation,
    options
  );
  return children({ updateCustomerToAmbassador });
};